import { tableButtonStyle } from '../global';

export const viewOptions = [
  { label: 'Event View', value: 'event-view' },
  {
    label: 'Age View',
    value: 'age-view',
  },
];

// Filtering for this table is done by the Events page dropdowns, not by
// column flags, so these columns carry no filter configuration.
export const columns = [
  {
    accessor: 'eventTypeValue',
    label: 'Event',
    checkbox: false,
    headerStyle: {
      paddingLeft: 20,
      paddingRight: 25,
      justifyContent: 'space-between',
    },
    style: {
      paddingLeft: 20,
    },
  },
  {
    accessor: 'gender',
    label: 'Gender',
    checkbox: false,
    headerStyle: {
      paddingLeft: 22,
      paddingRight: 5,
      minWidth: 58,
    },
    style: {
      paddingLeft: 22,
      minWidth: 58,
    },
  },
  {
    accessor: 'ageGroup',
    label: 'Age Group',
    checkbox: false,
    headerStyle: {
      paddingLeft: 22,
      paddingRight: 5,
      minWidth: 58,
    },
    style: {
      paddingLeft: 22,
      minWidth: 58,
    },
  },
  {
    accessor: 'rounds',
    label: 'Rounds',
    checkbox: false,
    headerStyle: {
      paddingLeft: 20,
    },
    style: {
      paddingLeft: 20,
    },
  },
  {
    accessor: 'manage',
    label: 'Results',
    headerStyle: {
      paddingLeft: 20,
      minWidth: 145,
    },
    style: {
      ...tableButtonStyle,
      backgroundColor: 'transparent',
      margin: '0 auto 0 5px',
      minWidth: 140,
    },
  },
];

export const ATTEMPT_MAX_COUNT = 6;

// Field events that record a DISTANCE over up to ATTEMPT_MAX_COUNT attempts.
// High Jump is deliberately NOT listed: it uses a height ladder with
// per-height attempts, its own result API and its own views, and
// ResultEditPopup relies on `fieldEvents.includes(eventType)` being false for
// it to route saves/deletes correctly. Do not add it here. If you need "every
// field discipline" (e.g. for sorting), keep a local list instead.
export const fieldEvents = [
  'Long Jump',
  'Triple Jump',
  'Discus',
  'Javelin',
  'Shot Put',
  // A throw, typed on the website only: neither app can record it (register
  // R45, docs/school-carnivals-step-3-relays.md).
  'Vortex',
];

export const isJumpingEvent = (eventType) => {
  return ['Long Jump', 'Triple Jump'].includes(eventType);
};
